module.exports = __webpack_public_path__ + "static/media/Jill E. Stein - 2016.eb6b42f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Jill E. Stein - 2016.jpg
// module id = 508
// module chunks = 0